module.exports = new __parcel__URL__("air-quality-and-covid-19--story-cover.223fafff.jpg").toString();